<div class="row">
  <div class="col-md-12 col-sm-12">
    <div class="card">
      <div class="card-header text-center">
        <h5>LISTA DE PEDIDOS</h5>
      </div>
      <div class="card-body">
        <div class="row">

          Lista de pedidos seleccionados:
<div *ngFor="let chkbox of Array">
   <span style="margin: 5px;" class="badge bg-warning"> {{chkbox}} </span>
</div>
<button
 
 (click)="crearPDF()"
 class="btn btn-primary"
>
 <i class="fa fa-print"></i>
</button>

<button
 
 (click)="crearPDFMonetizado()"
 class="btn btn-success"
>
 <i class="fa fa-print"></i>
</button>
          <div class="col-md-12">
            <input
              class="form-control"
              #searchTerm
              (keyup)="search(searchTerm.value)"
              placeholder="Buscar pedidos..."
            />
          </div>
        </div>
        <br />

        <div *ngIf="pedidos && !orderService.isLoading">
          <table class="table table-bordered table-condensed table-hover table-sm table-md">
            <thead>
              <tr class="text-center">
                <th># Ped</th>
                <th>Estado</th>
                <th>F. Registro</th>
                <th>F. Entrega</th>
                <th>Cliente</th>
                <th>Vendedor</th>
                <th>Total</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody *ngFor="let order of pedidos.data; let i = index">
              <tr>
                <th>{{ order.orden_id }}</th>
                <td class="text-center">
                  <span class="badge badge-info">{{ order.estado }}</span>
                </td>
                <td class="text-center">
                  {{ order.fecha | date: 'dd/MM/yyyy' }}
                </td>
                <td class="text-center">
                  {{ order.fecha_entrega | date: 'dd/MM/yyyy' }}
                </td>
                <td style="width: 180px;">
                  {{ order.cliente.nombres }} {{ order.cliente.apellidos }}
                </td>
                <td>
                  {{ order.vendedor.nombres }} {{ order.vendedor.apellidos }}
                </td>
                <td style="width: 80px;">
                  {{ order.total }}
                </td>
                <td style="width: 180px;">
                 
                    <div *ngIf="order.estado != 'CONCLUIDO'">
                      <a
                        *hasPermission="['vendedor']"
                        class="btn btn-info text-white"
                        [routerLink]="['/dashboard/order-edit', order.orden_id]"
                      >
                        Detalle
                      </a>

                      <button
                        *ngIf="order.estado != 'ANULADO'"
                        type="button"
                        (click)="eliminar(order.orden_id)"
                        class="btn btn-danger"
                      >
                        <i class="fa fa-trash" ></i>
                      </button>
                      <span *ngIf="order.estado == 'PEDIDO'">
                        <a
                          *hasPermission="['administrador', 'almacen']"
                          class="btn btn-info text-white"
                          [routerLink]="[
                            '/dashboard/order-edit',
                            order.orden_id
                          ]"
                        >
                        <i class="fa fa-send"></i>

                        </a>
                      </span>
                      <span *ngIf="order.estado == 'DESPACHADO'">
                        <a
                          *hasPermission="['administrador', 'almacen']"
                          class="btn btn-warning text-white"
                          [routerLink]="[
                            '/dashboard/order-edit',
                            order.orden_id
                          ]"
                        >
                          Vender
                        </a>
                      </span>
                      <button
                      *ngIf="order.estado == 'PEDIDO'"
                      (click)="showPDF(order.orden_id)"
                      class="btn btn-primary"
                    >
                      <i class="fa fa-print"></i>
                    </button>

                    </div>
                   

                    <button
                    type="button"
                    *ngIf="
                        order.estado == 'DESPACHADO' ||
                        order.estado == 'CONCLUIDO'
                      "
                    class="btn btn-sm btn-icon btn-pure btn-outline "
                    title="Descargar"
                    (click)="showPDF(order.order_id)"
                  >
                    <i class="fas fa-print text-inverse text-info" style="font-size: 25px"></i>
                  </button>

                    
                </td>
                <td>
                  <input name="checkboxName" id="checkbox2" type="checkbox" value="Value 2" 
                  (change)="$event.target.checked? (isfrmChecked = true) : isfrmChecked = false; componentMethodName($event,isfrmChecked, order.orden_id);">

                </td>
              </tr>
            </tbody>
          </table>
          <p>
            Mostrando pedidos {{ pedidos.from }} a {{ pedidos.to }} de
            {{ pedidos.total }}
          </p>
          <p>Página {{ pedidos.current_page }} de {{ pedidos.last_page }}</p>

          <input type="number" style="width: 50px;"
              [(ngModel)]="paginanum" name="home" required min="0" step="1">
              <button (click)="searchPage(paginanum)" >
               ir
             </button>
        <br>


          <button (click)="prevPage()" [disabled]="!pedidos.prev_page_url">
            Anterior
          </button>
          <button (click)="nextPage()" [disabled]="!pedidos.next_page_url">
            Siguiente
          </button>
        </div>
        <p *ngIf="orderService.isLoading">Cargando...</p>
      </div>
    </div>
  </div>
</div>
